import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Self,Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonHelperService } from '../../CommonUtility/common-helper.service';
import { toInteger } from '../../CommonUtility/util';
import { PageType, StatusCode } from '../../Models/EnumHelper';
import { AddressModel, UserAddress, UserAddressModel } from '../../Models/user-data.model';
import { CreditGeniusService } from '../../../Services/credit-genius.service';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../../Components/navbar/navbar.component';
import { FooterComponent } from '../../Components/footer/footer.component';


@Component({
  selector: 'app-address-details',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NavbarComponent,
    FooterComponent
  ],
  templateUrl: './address-details.component.html',
  styleUrls: ['./address-details.component.css']
})
export class AddressDetailsComponent implements OnInit {
  imgSrc = environment.imgBasURL;
  navType: PageType = PageType.address
  AddressForm!: FormGroup;
  addresses0: AddressModel[] = [];
  addresses1: AddressModel[] = [];
  addresses2: AddressModel[] = [];
  message!: string;
  YearStack: any = [];
  HomeOwnerStatus!: any[];
  submitted = false;
  currDiv: string = 'B';
  EndMonth1!: number;
  EndYear1!: number;
  EndMonth2!: number;
  EndYear2!: number;
  IsFutureDate: boolean = false;
  StartDate: any = [];
  EndDate: any = [];
  totalSpent: number = 0;
  firsttotal = 0;
  secondtotal = 0;
  substitue_totalSpent1: number = 0;
  substitue_totalSpent2: number = 0;
  substitue_totalSpent3: number = 0;
  noofform: number = 1;
  LessthanthreeYearMsg1: boolean = false;
  LessthanthreeYearMsg2: boolean = false;
  LessthanthreeYearMsg3: boolean = false;
  IsAddressShow0: boolean = false;
  IsAddressShow1: boolean = false;
  IsAddressShow2: boolean = false;
  IsYearMonthShow0: boolean = false;
  IsYearMonthShow1: boolean = false;
  IsYearMonthShow2: boolean = false;
  IsExceededDateFirst: boolean = false;
  IsExceededDateSec: boolean = false;
  IsLiveOutSideUk2: boolean = false;
  BtnDisable: boolean = false;
  IsShowMannualAddress0: boolean = false;
  IsShowMannualAddress1: boolean = false;
  IsShowMannualAddress2: boolean = false;

  Errmsg1: boolean = false;
  Errmsg2: boolean = false;
  Errmsg3: boolean = false;
  Errmsgs1: any;
  Errmsgs2: any;
  Errmsgs3: any;
  InvalidPostcode1: boolean = false;
  InvalidPostcode2: boolean = false;
  InvalidPostcode3: boolean = false;
  PostcodeLoader1: boolean = false;
  PostcodeLoader2: boolean = false;
  PostcodeLoader3: boolean = false;

  selectedAddressItem1: any;
  selectedAddressItem2: any;
  selectedAddressItem3: any;

  CustomerId!: string;
  addressReq = new UserAddressModel('', 0, []);
  IsAddressLoaded: boolean = false;
  IsManualDisabled!: boolean;
  IsOnehouseRequired: boolean = true;
  linkDynamicAddress0: boolean = false;
  linkDynamicAddress1: boolean = false;
  linkDynamicAddress2: boolean = false;
  userAddress: UserAddress[] = [];
  AddressMessage:string = '';
  PrefilledData: any;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _creditGeniusService: CreditGeniusService,
    private _commonHelper: CommonHelperService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: object
  ) {

      if (isPlatformBrowser(this.platformId)) {
      this.CustomerId = sessionStorage.getItem('customer') || '';
    }
   
  }

  ngOnInit(): void {
    this.AddressForm = this.formBuilder.group({
      addhistory: this.formBuilder.array([])
    });

    this.AddForm(this.noofform);
    this.InitializeYears();
    this.GetHomeOwenrship();

    this.route.queryParams.subscribe(params => {
      if (params != null) {
        if (params['tag'] === undefined) {
          
        }
        else if (params['tag'] === 'back') {          
          let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
          window.history.pushState({ path: newurl }, '', newurl);
          
        }
      }
    });
    //window.scrollTo(0, 0)
    if (isPlatformBrowser(this.platformId)) {
    if (sessionStorage.getItem('AddressDetails')) {
      this.PrepopulateData();
    }}
  }

  get f() { return this.AddressForm.controls; }
  get t() { return this.f['addhistory'] as any; }

  Errmsg(i: any) {
    if (i == 1) { return this.Errmsg1 }
    if (i == 2) { return this.Errmsg2 }
    if (i == 3) { return this.Errmsg3 }
    return null;
  }

  Errmsgs(i: any) {
    if (i == 1) { return this.Errmsgs1 }
    if (i == 2) { return this.Errmsgs2 }
    if (i == 3) { return this.Errmsgs3 }
  }

  IsInvalidPostcode(i: any) {
    if (i == 1) { return this.InvalidPostcode1; }
    if (i == 2) { return this.InvalidPostcode2; }
    if (i == 3) { return this.InvalidPostcode3; }
    return null;
  }

  IsPostcodeLoader(i: any) {
    if (i == 1) { return this.PostcodeLoader1; }
    if (i == 2) { return this.PostcodeLoader2; }
    if (i == 3) { return this.PostcodeLoader3; }
    return null;
  }

  getArray(i: number): any[] {
    if (i === 0) {
      return this.addresses0;
    } else if (i === 1) {
      return this.addresses1;
    } else if (i === 2) {
      return this.addresses2;
    }
    return [];
  }

  getIsAddressShow(i: number): any {
    if (i === 0) {
      return this.IsAddressShow0;
    } else if (i === 1) {
      return this.IsAddressShow1;
    } else if (i === 2) {
      return this.IsAddressShow2;
    }
  }

  InitializeYears() {
    var year = new Date().getFullYear();
    for (var i = 0; i < 51; i++) {
      this.YearStack.push({ id: i + 1, 'year': year - i });
    }
  }

  GetHomeOwenrship() {
    this.HomeOwnerStatus = [];
    this._creditGeniusService.GetHomeOwnership().subscribe((res: any) => {
      if (res?.data != null)
        this.HomeOwnerStatus = res.data;
    },
      (err: HttpErrorResponse) => {
        console.log('Catch exception: ' + err);
      });
  }

  checkonfindaddress(i: any) {
    if (i == 1) {
      this.InvalidPostcode1 = false;
      if (this.t.controls[i - 1].get('PostCode').value.length == 0) {
        this.t.controls[i - 1].get('PostCode').setErrors({ 'incorrect': true });
        this.Errmsg1 = true;
        this.Errmsgs1 = 'Please enter postcode';
      }
      else if (this.t.controls[i - 1].get('PostCode').value.length <= 3) {
        this.t.controls[i - 1].get('PostCode').setErrors({ 'incorrect': true });
        this.Errmsg1 = true;
        this.Errmsgs1 = 'Please enter a postcode of minimum length of 4 characters';
      }
      else {
        this.Errmsg1 = false;
        this.Errmsgs1 = "";
      }
    }
    if (i == 2) {
      this.InvalidPostcode2 = false;
      if (this.t.controls[i - 1].get('PostCode').value.length == 0) {
        this.t.controls[i - 1].get('PostCode').setErrors({ 'incorrect': true });
        this.Errmsg2 = true;
        this.Errmsgs2 = 'Please enter postcode';
      }
      else if (this.t.controls[i - 1].get('PostCode').value.length <= 3) {
        this.t.controls[i - 1].get('PostCode').setErrors({ 'incorrect': true });
        this.Errmsg2 = true;
        this.Errmsgs2 = 'Please enter a postcode of minimum length of 4 characters';
      }
      else {
        this.Errmsg2 = false;
        this.Errmsgs2 = "";
      }
    }
    if (i == 3) {
      this.InvalidPostcode3 = false;
      if (this.t.controls[i - 1].get('PostCode').value.length == 0) {
        this.t.controls[i - 1].get('PostCode').setErrors({ 'incorrect': true });
        this.Errmsg3 = true;
        this.Errmsgs3 = 'Please enter postcode';
      }
      else if (this.t.controls[i - 1].get('PostCode').value.length <= 3) {
        this.t.controls[i - 1].get('PostCode').setErrors({ 'incorrect': true });
        this.Errmsg3 = true;
        this.Errmsgs3 = 'Please enter a postcode of minimum length of 4 characters';
      }
      else {
        this.Errmsg3 = false;
        this.Errmsgs3 = "";
      }
    }
  }

  onfocus(i: any) {

    this.Errmsg1 = false;
    this.Errmsg2 = false;
    this.Errmsg3 = false;

    this.InvalidPostcode1 = false;
    this.InvalidPostcode2 = false;
    this.InvalidPostcode3 = false;

  }

  FindAddress(postcode: string, countNumber: number) {
    this.ResetApiValidation();
    this.ShowDiv('B', countNumber)
    if (postcode.length > 3) {

      if (countNumber == 1) { this.PostcodeLoader1 = true; }
      else if (countNumber == 2) { this.PostcodeLoader2 = true; }
      else if (countNumber == 3) { this.PostcodeLoader3 = true; }

      this._creditGeniusService.GetAddress(postcode).subscribe((res: any) => {
        if (res != null) {
          if (res.data?.length > 0) {
            if (countNumber == 1) {
              this.IsAddressShow0 = true;
              this.PostcodeLoader1 = false;
              this.InvalidPostcode1 = false;
              this.addresses0 = [];

              res.data.forEach((item:any) => {
                this.addresses0.push({ id: item.id, address: item.streetAddress + ',' + item.place });
              });
            }
            else if (countNumber == 2) {
              this.IsAddressShow1 = true;
              this.PostcodeLoader2 = false;
              this.InvalidPostcode2 = false;
              this.addresses1 = [];

              res.data.forEach((item:any) => {
                this.addresses1.push({ id: item.id, address: item.streetAddress + ',' + item.place });
              });
            }
            else if (countNumber == 3) {
              this.IsAddressShow2 = true;
              this.PostcodeLoader3 = false;
              this.InvalidPostcode3 = false;
              this.addresses2 = [];

              res.data.forEach((item:any) => {
                this.addresses2.push({ id: item.id, address: item.streetAddress + ',' + item.place });
              });
            }
          }
          else {
            if (countNumber == 1) {
              this.InvalidPostcode1 = true;
              this.PostcodeLoader1 = false;
            }
            if (countNumber == 2) {
              this.InvalidPostcode2 = true;
              this.PostcodeLoader2 = false;
            }
            if (countNumber == 3) {
              this.InvalidPostcode3 = true;
              this.PostcodeLoader3 = false;
            }
          }
        }
      }, (err: HttpErrorResponse) => {
        console.log('Catch exception: ' + err);
      });
    }
    else {
      
      this.message = 'Postcode should be more than 3 character';
      this.checkonfindaddress(countNumber);
      
    }
  }

  AddForm(value:any) {
    const numberOfform = value || 1;
    if (this.t.length < numberOfform) {
      for (let i = this.t.length; i < numberOfform; i++) {
        this.t.push(this.formBuilder.group({
          PostCode: [''],
          AddressId: [''],
          Month: [''],
          Year: [''],
          StartDate: [''],
          EndDate: [''],
          ResidentialStatus: [''],
          IsLiveOutSideUk: [false],
          NoOfAddress: [i + 1],
          FlatNumber:[''], HouseName:[''], HouseNo:[''], Street:[''], Town:[''], Country:[''], FullAddress:['']
        }));

       
      }
      this.CutomValidation(numberOfform, 'Add');

    } else {
      for (let i = this.t.length; i >= numberOfform; i--) {
        this.t.removeAt(i);
      }
    }
  }

  CutomValidation(SelectedNumber:any, ValidationStatus: string) {
    if (SelectedNumber == 1 && ValidationStatus == 'Add') {
      this.t.controls[SelectedNumber - 1].get('PostCode').setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(8)]);
      this.t.controls[SelectedNumber - 1].get('PostCode').updateValueAndValidity();

      if (this.IsShowMannualAddress0 == false) {
        this.t.controls[SelectedNumber - 1].get('AddressId').setValidators([Validators.required]);
        this.t.controls[SelectedNumber - 1].get('AddressId').updateValueAndValidity();
      }
      else {
        // function to validate manual address this.ValidateMannualAddress
        this.ValidateMannualAddress(SelectedNumber);
      }

      this.t.controls[SelectedNumber - 1].get('Month').setValidators([Validators.required]);
      this.t.controls[SelectedNumber - 1].get('Month').updateValueAndValidity();
      this.t.controls[SelectedNumber - 1].get('Year').setValidators([Validators.required]);
      this.t.controls[SelectedNumber - 1].get('Year').updateValueAndValidity();

      this.t.controls[SelectedNumber - 1].get('ResidentialStatus').setValidators([Validators.required]);
      this.t.controls[SelectedNumber - 1].get('ResidentialStatus').updateValueAndValidity();
    }
    else if (SelectedNumber == 2) {
      if (ValidationStatus == 'Add') {
        this.t.controls[SelectedNumber - 1].get('PostCode').setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(8)]);
        this.t.controls[SelectedNumber - 1].get('PostCode').updateValueAndValidity();

        if (this.IsShowMannualAddress1 == false) {
          this.t.controls[SelectedNumber - 1].get('AddressId').setValidators([Validators.required]);
          this.t.controls[SelectedNumber - 1].get('AddressId').updateValueAndValidity();
        }
        else {
          // function to validate manual address this.ValidateMannualAddress
          this.ValidateMannualAddress(SelectedNumber);
        }

        this.t.controls[SelectedNumber - 1].get('Month').setValidators([Validators.required]);
        this.t.controls[SelectedNumber - 1].get('Month').updateValueAndValidity();
        this.t.controls[SelectedNumber - 1].get('Year').setValidators([Validators.required]);
        this.t.controls[SelectedNumber - 1].get('Year').updateValueAndValidity();
      }
      else if (ValidationStatus == 'Remove') {
        this.t.controls[SelectedNumber - 1].get('PostCode').clearValidators();
        this.t.controls[SelectedNumber - 1].get('PostCode').updateValueAndValidity();

        this.t.controls[SelectedNumber - 1].get('AddressId').clearValidators();
        this.t.controls[SelectedNumber - 1].get('AddressId').updateValueAndValidity();

        this.t.controls[SelectedNumber - 1].get('Month').clearValidators();
        this.t.controls[SelectedNumber - 1].get('Month').updateValueAndValidity();

        this.t.controls[SelectedNumber - 1].get('Year').clearValidators();
        this.t.controls[SelectedNumber - 1].get('Year').updateValueAndValidity();
      }
    }
    else if (SelectedNumber == 3) {
      if (ValidationStatus == 'Add') {
        this.t.controls[SelectedNumber - 1].get('PostCode').setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(8)]);
        this.t.controls[SelectedNumber - 1].get('PostCode').updateValueAndValidity();

        if (this.IsShowMannualAddress2 == false) {
          this.t.controls[SelectedNumber - 1].get('AddressId').setValidators([Validators.required]);
          this.t.controls[SelectedNumber - 1].get('AddressId').updateValueAndValidity();
        }
        else {
          // function to validate manual address this.ValidateMannualAddress
          this.ValidateMannualAddress(SelectedNumber);
        }
        this.t.controls[SelectedNumber - 1].get('Month').setValidators([Validators.required]);
        this.t.controls[SelectedNumber - 1].get('Month').updateValueAndValidity();
        this.t.controls[SelectedNumber - 1].get('Year').setValidators([Validators.required]);
        this.t.controls[SelectedNumber - 1].get('Year').updateValueAndValidity();
      }
      else if (ValidationStatus == 'Remove') {
        this.t.controls[SelectedNumber - 1].get('PostCode').clearValidators();
        this.t.controls[SelectedNumber - 1].get('PostCode').updateValueAndValidity();
        this.t.controls[SelectedNumber - 1].get('AddressId').clearValidators();
        this.t.controls[SelectedNumber - 1].get('AddressId').updateValueAndValidity();
        this.t.controls[SelectedNumber - 1].get('Month').clearValidators();
        this.t.controls[SelectedNumber - 1].get('Month').updateValueAndValidity();
        this.t.controls[SelectedNumber - 1].get('Year').clearValidators();
        this.t.controls[SelectedNumber - 1].get('Year').updateValueAndValidity();
      }
    }
  }

  getlinkDynamicAddress(i: number): any {
    if (i === 0) {
      return this.linkDynamicAddress0;
    } else if (i === 1) {
      return this.linkDynamicAddress1;
    } else if (i === 2) {
      return this.linkDynamicAddress2;
    }
  }

  geIsYearMonthShow(i: number): any {
    if (i === 0) {
      return this.IsYearMonthShow0;
    } else if (i === 1) {
      return this.IsYearMonthShow1;
    } else if (i === 2) {
      return this.IsYearMonthShow2;
    }
  }

  OneHouseRequiredValidation(event:any, i:any): any {
    let HouseNumber = this.t.controls[i].get('HouseNo')?.value;
    let HouseName = this.t.controls[i].get('HouseName')?.value;    
    if((HouseNumber == null && HouseName == null) || (HouseNumber?.length < 1 && HouseName?.length < 1))
    {
      this.IsOnehouseRequired = true;
    }
    else
    {
      this.IsOnehouseRequired = false;
    }
 }

  onChangeaddress(event:any, selected:any) {
    this.ResetApiValidation();
    if (event.target == undefined || event.target == null) {
      var value = event;
    }
    else {
      var value = event.target.value;
    }
    if (value != '' || value != undefined || value != null) {
      if (selected == 1) {
        this.IsYearMonthShow0 = true;
      } else if (selected == 2) {
        this.IsYearMonthShow1 = true;
      } else if (selected == 3) {
        this.IsYearMonthShow2 = true;
      }
    }
  }

  getIsShowMannualAddress(i: number): any {
    if (i === 0) {
      return this.IsShowMannualAddress0;
    } else if (i === 1) {
      return this.IsShowMannualAddress1;
    } else if (i === 2) {
      return this.IsShowMannualAddress2;
    }
  }

  // ShowMannualAddress(state: boolean, i: number) {
    ShowDiv(divVal: string, i: number) {
      this.currDiv = divVal;
    //this.IsOnehouseRequired = true;
    if (this.currDiv == 'A') {
      this.ResetApiValidation();
      this.t.controls[i - 1].get('AddressId').setValue('');
      this.t.controls[i - 1].get('AddressId').disable();
      this.onfocus(i-1)
      if (i - 1 == 0)  //this.getIsAddressShow(0)
      {
        this.IsAddressShow0 = false;
        this.IsYearMonthShow0 = true;
        this.IsShowMannualAddress0 = true;
        this.linkDynamicAddress0 = true;
        this.CutomValidation(i, 'Add');
      }
      else if (i - 1 == 1) //this.getIsAddressShow(1)
      {
        this.IsAddressShow1 = false;
        this.IsYearMonthShow1 = true;
        this.IsShowMannualAddress1 = true;
        this.linkDynamicAddress1 = true;
        this.CutomValidation(i, 'Add');
      }
      else {
        this.IsAddressShow2 = false;
        this.IsYearMonthShow2 = true;
        this.IsShowMannualAddress2 = true;
        this.linkDynamicAddress2 = true;
        this.CutomValidation(i, 'Add');
      }
    }
    else {
      this.t.controls[i - 1].get('AddressId').enable();
      if (i - 1 == 0) {
        this.IsAddressShow0 = false;
        this.IsYearMonthShow0 = false;
        this.IsShowMannualAddress0 = false;
        this.linkDynamicAddress0 = false;
        this.RemoveValidateMannualAddress(i);
      }
      else if (i - 1 == 1) {
        this.IsAddressShow1 = false;
        this.IsYearMonthShow1 = false;
        this.IsShowMannualAddress1 = false;
        this.linkDynamicAddress1 = false;
        this.RemoveValidateMannualAddress(i);
      }
      else {
        this.IsAddressShow2 = false;
        this.IsYearMonthShow2 = false;
        this.IsShowMannualAddress2 = false;
        this.linkDynamicAddress2 = false;
        this.RemoveValidateMannualAddress(i);
      }
    }
  }

  ValidateMannualAddress(SelectedNumber:any) {
    this.t.controls[SelectedNumber - 1].get('FlatNumber').setValidators([ Validators.pattern('^[A-Za-z0-9 ]+$')]);
    this.t.controls[SelectedNumber - 1].get('FlatNumber').updateValueAndValidity();
    this.t.controls[SelectedNumber - 1].get('FlatNumber').setValue('');

    this.t.controls[SelectedNumber - 1].get('HouseName').setValidators([Validators.pattern('^[A-Za-z0-9 ]*$')]);
    this.t.controls[SelectedNumber - 1].get('HouseName').updateValueAndValidity();
    this.t.controls[SelectedNumber - 1].get('HouseName').setValue('');

    this.t.controls[SelectedNumber - 1].get('HouseNo').setValidators([Validators.pattern('^[A-Za-z0-9 ]*$')]);
    this.t.controls[SelectedNumber - 1].get('HouseNo').updateValueAndValidity();
    this.t.controls[SelectedNumber - 1].get('HouseNo').setValue('');

    this.t.controls[SelectedNumber - 1].get('Street').setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9 ]*$')]);
    this.t.controls[SelectedNumber - 1].get('Street').updateValueAndValidity();

    this.t.controls[SelectedNumber - 1].get('Town').setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9 ]*$')]);
    this.t.controls[SelectedNumber - 1].get('Town').updateValueAndValidity();

    this.t.controls[SelectedNumber - 1].get('Country').setValidators([ Validators.pattern('^[a-zA-Z ]*$')]);
    this.t.controls[SelectedNumber - 1].get('Country').updateValueAndValidity();
  }

  RemoveValidateMannualAddress(SelectedNumber:any)
  {
    this.t.controls[SelectedNumber - 1].get('FlatNumber').clearValidators();
    this.t.controls[SelectedNumber - 1].get('FlatNumber').reset();
    this.t.controls[SelectedNumber - 1].get('FlatNumber').updateValueAndValidity();

    this.t.controls[SelectedNumber-1].get('HouseName').clearValidators();
    this.t.controls[SelectedNumber-1].get('HouseName').reset();
    this.t.controls[SelectedNumber - 1].get('HouseName').updateValueAndValidity();

    this.t.controls[SelectedNumber-1].get('HouseNo').clearValidators();
    this.t.controls[SelectedNumber-1].get('HouseNo').reset();
    this.t.controls[SelectedNumber - 1].get('HouseNo').updateValueAndValidity();

    this.t.controls[SelectedNumber-1].get('Street').clearValidators();
    this.t.controls[SelectedNumber-1].get('Street').reset();
    this.t.controls[SelectedNumber - 1].get('Street').updateValueAndValidity();

    this.t.controls[SelectedNumber - 1].get('Town').clearValidators();
    this.t.controls[SelectedNumber - 1].get('Town').reset();
    this.t.controls[SelectedNumber - 1].get('Town').updateValueAndValidity();

    this.t.controls[SelectedNumber - 1].get('Country').clearValidators();
    this.t.controls[SelectedNumber - 1].get('Country').reset();
    this.t.controls[SelectedNumber - 1].get('Country').updateValueAndValidity();
  }

  GetAddressHistory(SelectedYear:any, SelectedMonth:any, SelectedNumber:any) {
    if(this.AddressMessage != ''){
      return;
    }
    if (Number(SelectedYear) != undefined && SelectedYear != '' && SelectedMonth != undefined && SelectedMonth != '') {
      if (SelectedNumber == 1) {
        // default date of system
        let System_year = new Date().getFullYear();
        let System_month = new Date().getMonth() + 1;

        // SelectedYear and SelectedMonth are passed to EndDates for 2nd form
        this.EndYear1 = SelectedYear = parseInt(SelectedYear);
        this.EndMonth1 = SelectedMonth = parseInt(SelectedMonth);

        if (System_year == this.EndYear1 && this.EndMonth1 > System_month) {
          this.IsFutureDate = true;
        }
        else {
          this.IsFutureDate = false;
        }

        this.StartDate[SelectedNumber - 1] = SelectedYear + '-' + SelectedMonth;
        this.EndDate[SelectedNumber - 1] = System_year + '-' + System_month;

        this.totalSpent = ((System_year - SelectedYear) * 12) + (System_month - SelectedMonth);
        this.firsttotal = ((System_year - SelectedYear) * 12);

        this.substitue_totalSpent1 = this.totalSpent;
        this.substitue_totalSpent2 = 0;

        this.StartDate[SelectedNumber - 1] = new Date(Date.UTC(SelectedYear, SelectedMonth - 1, 1));
        this.EndDate[SelectedNumber - 1] = new Date(Date.UTC(System_year, System_month, 0));

        // set data in formcontrol dynamiclly
        this.t.controls[SelectedNumber - 1].get('StartDate').setValue(this.StartDate[SelectedNumber - 1]);
        // passing null because current address shouldn't enddate
        this.t.controls[SelectedNumber - 1].get('EndDate').setValue(null);

        if (this.totalSpent < 36 && this.IsFutureDate == false) {
          this.noofform = 2;
          this.LessthanthreeYearMsg1 = true;
          this.AddForm(this.noofform);
        } else {
          this.noofform = 1;
          this.AddForm(this.noofform);
          this.LessthanthreeYearMsg1 = false;
          this.IsYearMonthShow1 = false;
          this.IsAddressShow1 = false;
          this.IsYearMonthShow2 = false;
          this.IsAddressShow2 = false;

        }
      } else if (SelectedNumber == 2) {
        // SelectedYear and SelectedMonth are passed to EndYear2 and EndMonth2 for 3nd form
        this.EndYear2 = SelectedYear = parseInt(SelectedYear);
        this.EndMonth2 = SelectedMonth = parseInt(SelectedMonth);

        this.totalSpent = this.substitue_totalSpent1 + ((this.EndYear1 - SelectedYear) * 12) + (this.EndMonth1 - SelectedMonth);
        this.secondtotal = ((this.EndYear1 - SelectedYear) * 12) + this.firsttotal;
        if (this.EndYear1 == this.EndYear2 && this.EndMonth2 >= this.EndMonth1) {
          this.IsExceededDateFirst = true;
        }
        else if (this.EndYear2 > this.EndYear1) {
          this.IsExceededDateFirst = true;
        }
        else {
          this.IsExceededDateFirst = false;
        }
        this.substitue_totalSpent2 = this.totalSpent;
        this.substitue_totalSpent3 = 0;

        this.StartDate[SelectedNumber - 1] = SelectedYear + '-' + SelectedMonth;
        this.EndDate[SelectedNumber - 1] = this.EndYear1 + '-' + this.EndMonth1;

        this.StartDate[SelectedNumber - 1] = new Date(Date.UTC(SelectedYear, SelectedMonth - 1, 1));
        this.EndDate[SelectedNumber - 1] = new Date(Date.UTC(this.EndYear1, this.EndMonth1 - 1, 0));

        this.t.controls[SelectedNumber - 1].get('StartDate').setValue(this.StartDate[SelectedNumber - 1]);
        this.t.controls[SelectedNumber - 1].get('EndDate').setValue(this.EndDate[SelectedNumber - 1]);

        if (this.totalSpent < 36) {
          if (this.IsExceededDateFirst == false) {
            this.noofform = 3;
            this.LessthanthreeYearMsg2 = true;
            //this.t.controls[this.noofform - 3].get('IsLiveOutSideUk').setValue(false);
            //this.t.controls[this.noofform - 2].get('IsLiveOutSideUk').setValue(false);
            this.IsLiveOutSideUk2 = false;
            this.AddForm(this.noofform);
          }
          else {
            this.BtnDisable = true;
            this.noofform = 2;
            //this.t.controls[this.noofform - 2].get('IsLiveOutSideUk').setValue(false);
            this.AddForm(this.noofform);
          }

        }
        if (this.totalSpent >= 36) {
          this.BtnDisable = false;
          this.noofform = 2;
          //this.t.controls[this.noofform - 2].get('IsLiveOutSideUk').setValue(false);
          this.LessthanthreeYearMsg2 = false;
          this.AddForm(this.noofform);
          this.IsYearMonthShow2 = false;
          this.IsAddressShow2 = false;
        }
      } else if (SelectedNumber == 3) {
        this.totalSpent = this.substitue_totalSpent2 + ((this.EndYear2 - SelectedYear) * 12) + (this.EndMonth2 - SelectedMonth);
        if (this.EndYear2 == SelectedYear && SelectedMonth >= this.EndMonth2) {
          this.IsExceededDateSec = true;
        }
        else if (SelectedYear > this.EndYear2) {
          this.IsExceededDateSec = true;
        }
        else {
          this.IsExceededDateSec = false;
        }
        this.StartDate[SelectedNumber - 1] = SelectedYear + '-' + SelectedMonth;
        this.EndDate[SelectedNumber - 1] = this.EndYear2 + '-' + this.EndMonth2;

        this.StartDate[SelectedNumber - 1] = new Date(Date.UTC(SelectedYear, SelectedMonth - 1, 1));
        this.EndDate[SelectedNumber - 1] = new Date(Date.UTC(this.EndYear2, this.EndMonth2 - 1, 0));

        this.t.controls[SelectedNumber - 1].get('StartDate').setValue(this.StartDate[SelectedNumber - 1]);
        this.t.controls[SelectedNumber - 1].get('EndDate').setValue(this.EndDate[SelectedNumber - 1]);

        this.substitue_totalSpent3 = this.totalSpent;

        // logic to make address history atleast of 3 years if entered history is less than this.
        if (this.totalSpent < 36) {
          this.totalSpent = this.totalSpent + (36 - this.substitue_totalSpent3)
        }
        if (this.totalSpent >= 36) {
          this.BtnDisable = false;
          //this.t.controls[SelectedNumber - 2].get('IsLiveOutSideUk').setValue(false);
          this.LessthanthreeYearMsg3 = false;
        }
      }
    } else {
      return;
    }
  }

  selectResidence(event: any, countNumber: number) {
    this.t.controls[countNumber].get('ResidentialStatus').setValue(event.target.value);
  }
  
  selectAddress(event: any, formNumber: number) {
    this.t.controls[formNumber].get('AddressId').setValue(event.target.value);
    switch (formNumber) {
      case 0:
        this.selectedAddressItem1 = event.target.value;
        //this.tab = 'tab1';
        break;
      case 1:
        this.selectedAddressItem2 = event.target.value;
        //this.tab = 'tab2';
        break;
      case 2:
        this.selectedAddressItem3 = event.target.value;
        //this.tab = 'tab3';
        break;
      default:        
        break;
    }    
  }

  selectedAddressItem(i: number) {
    if (i == 1) { return this.selectedAddressItem1 }
    else if (i == 2) { return this.selectedAddressItem2 }
    else if (i == 3) { return this.selectedAddressItem3 }
    return null;
  }

  onSubmit() {
    this.router.navigate(['/financial']); //TODO: remove this line when address api is ready
    this.submitted = true;
    this.IsAddressLoaded = true;
    this.userAddress = [];    
    this.AddressMessage = ''
    if (this.AddressForm.invalid) {
      this.IsAddressLoaded = false;
      return;
    }
    else {

      if (this.t.value.length > 0) {
        this.addressReq.CustomerId = this.CustomerId;
        if (this.t.value[0].ResidentialStatus != '') {
          this.addressReq.ResidentialStatus = toInteger(this.t.value[0].ResidentialStatus);
        }

        this.t.value.forEach((item:any) => {
          if(item.AddressId == '' || item.AddressId == undefined || item.AddressId == null)
          {
            var FullAddress = '';
            if(item.FlatNumber?.trim() != '')
                FullAddress = item.FlatNumber?.trim() + ',';
            if(item.HouseName?.trim() != '')
                FullAddress += item.HouseName?.trim() + ',';
            if(item.HouseNo?.trim() != '')
                FullAddress += item.HouseNo?.trim() + ',';
            FullAddress += item.Street+','+ item.Town+','+item.Country;
            item.FullAddress = FullAddress.trim();
          }
          if (item.PostCode != '' && item.AddressId != '' && item.Year != '' && item.Month != '') {
            const data: UserAddress = {
              Postcode: item.PostCode,
              AddressId: item.AddressId,
              Month: item.Month,
              Year: item.Year,
              StartDate: item.StartDate,
              EndDate: item.EndDate,
              NoOfAddress: item.NoOfAddress,
              IsLiveOutSideUk: item.IsLiveOutSideUk,
              FlatNumber: item.FlatNumber,
              HouseName: item.HouseName,
              HouseNo: item.HouseNo,
              Street: item.Street,
              Town: item.Town,
              Country: item.Country,
              FullAddress: item.FullAddress
            }
            this.userAddress.push(data);
          }
        });
        this.addressReq.UserAddresses = this.userAddress;
        sessionStorage.setItem('AddressDetails', JSON.stringify(this.addressReq));
        
        this._creditGeniusService.SaveUserAddress(this.addressReq).subscribe((res: any) => {
          if (res != null && res.statusCode == StatusCode.Success && res.data != null) {
            this.IsAddressLoaded = false;
            // Comment Step number related code 
            // this._commonHelper.SetStepNumber(2);
            //window.scrollTo(0, 0)
            //this._commonHelper.SetAddressDetails(this.addressReq);
            this.router.navigate(['/financial']);
          }else if(res != null && res.statusCode == StatusCode.NotValidAddress){
            this.AddressMessage = res.message;
            this.IsAddressLoaded = false;
          }
        },
          (err: HttpErrorResponse) => {
            this.IsAddressLoaded = false;
            console.log('Catch exception: ' + err);
          }
        );
        
      }

    }
    

  }

  AddFormWithValue(value:any) {
    const numberOfform = value || 1;
    if (this.t.length < numberOfform) {
      for (let i = this.t.length; i < numberOfform; i++) {
        this.t.push(this.formBuilder.group({
          PostCode: [''],
          AddressId: [''],
          Month: [''],
          Year: [''],
          StartDate: [''],
          EndDate: [''],
          ResidentialStatus: [''],
          IsLiveOutSideUk: [false],
          NoOfAddress: [i + 1],
        }));
      }
      this.CutomValidation(numberOfform, 'Add');
    } else {
      for (let i = this.t.length; i >= numberOfform; i--) {
        this.t.removeAt(i);
      }
    }

  }

  getIsExceededDateFirst(i: number): any {
    if (i == 2 && this.IsExceededDateFirst == true) { return true; }
    else if (i == 3 && this.IsExceededDateSec == true) { return true; }
    else
      return false;
  }

  getIsFutureDate(i: number): any {
    if (i == 1 && this.IsFutureDate == true) { return true; }
    else
      return false;
  }

  PrepopulateData() {
    this.PrefilledData = JSON.parse(sessionStorage.getItem('AddressDetails') || '{}');

    for (let i = 0; i < this.PrefilledData.UserAddresses.length; i++) {
      this.AddForm(i + 1)
      this.t.controls[i].get('PostCode').setValue(this.PrefilledData.UserAddresses[i].Postcode);
      this.t.controls[i].get('Month').setValue(this.PrefilledData.UserAddresses[i].Month);
      this.t.controls[i].get('Year').setValue(this.PrefilledData.UserAddresses[i].Year);
      this.t.controls[i].get('ResidentialStatus').setValue(this.PrefilledData.ResidentialStatus);
      this.GetAddressHistory(this.PrefilledData.UserAddresses[i].Year,this.PrefilledData.UserAddresses[i].Month,i+1);
      if (this.PrefilledData.UserAddresses[i]?.AddressId) {
        this.FindAddress(this.PrefilledData.UserAddresses[i].Postcode, i + 1)
        this.t.controls[i].get('AddressId').setValue(this.PrefilledData.UserAddresses[i].AddressId);
      }
      else {
        this.ShowDiv('A', i + 1)
        this.t.controls[i].get('FlatNumber').setValue(this.PrefilledData.UserAddresses[i].FlatNumber);
        this.t.controls[i].get('HouseName').setValue(this.PrefilledData.UserAddresses[i].HouseName);
        this.t.controls[i].get('HouseNo').setValue(this.PrefilledData.UserAddresses[i].HouseNo);
        this.t.controls[i].get('Street').setValue(this.PrefilledData.UserAddresses[i].Street);
        this.t.controls[i].get('Town').setValue(this.PrefilledData.UserAddresses[i].Town);
        this.t.controls[i].get('Country').setValue(this.PrefilledData.UserAddresses[i].Country);
      }
    }
  }
  ResetApiValidation(){
    this.submitted = false;
    this.AddressMessage = ''
  }

}
